export default {
  footer: {
    presented: 'DevUI Design Presented',
  },
};
